import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Project } from '../../../models/project/project.model';
import { Results } from '../../../models/results/results.model';
import { ProjectCommunicationService } from '../../../communication/project-comms.service';
import { takeUntil } from 'rxjs/operators';
import { ConfiguredToastrService } from '../../../helper/toastr/configured-toastr.service';
import { AnessaTranslationInterface } from '../../../models/interfaces/anessa-translation.interface';
import { AnessaTranslationService } from '../../../helper/translation/anessa-translation.service';
import { BehaviorSubject } from 'rxjs';
import { UserpilotReloader } from '../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-flow',
  templateUrl: './flow.component.html',
  styleUrls: ['./flow.component.scss']
})
export class FlowComponent extends UserpilotReloader implements OnInit, OnDestroy, AnessaTranslationInterface {
  onDestroyNotifier = new EventEmitter();
  project: Project = null;
  results: Results = null;
  precision: number;

  trigger: string;

  reloadFlowEmitter = new BehaviorSubject<{ project: Project, results: Results }>({project: this.project, results: this.results});

  constructor(
    private projectCommService: ProjectCommunicationService,
    private toastrService: ConfiguredToastrService,
    private translationService: AnessaTranslationService
  ) {
    super();
  }

  ngOnInit() {
    this.projectCommService.resultsLoadedNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(loaded => {
        if (loaded) {
          this.project = new Project(this.projectCommService.getResultProjectState());
          this.results = this.projectCommService.getResults();
          this.precision = this.projectCommService.getPrecision();
          if (this.project || this.results) {
            this.reloadFlowEmitter.next({project: this.project, results: this.results});
          } else {
            this.toastrService.warning(this.translationService.get('RESULTS.ERRORS.NO_RESULTS'));
          }
        }
      });
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(language => {
        this.trigger = language;
      });
  }


  ngOnDestroy(): void {
    this.onDestroyNotifier.emit(true);
  }

}
